import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { PopupNames } from 'contexts/PopupContext';

import { usePopup } from 'hooks/usePopup';
import { getIsBanned } from 'store/auth/selectors';
import { logout } from 'store/auth/thunks';

export const useUserBanPopup = () => {
  const dispatch = useDispatch();

  const history = useHistory();
  const isUserHasBan = useSelector(getIsBanned);

  const { handleAction, handleClose, handleOpenForce } = usePopup(
    PopupNames.UserBan
  );

  handleAction.current = (action: { type: string }) => {
    if (action.type === 'close') {
      handleClose();
    }
  };

  // handle ban from ws
  useEffect(() => {
    const showPopup = async () => {
      if (isUserHasBan) {
        handleOpenForce(null);
        await dispatch(logout());
        history.push('/login');
      }
    };

    showPopup();
  }, [dispatch, handleOpenForce, history, isUserHasBan]);

  return {
    handleOpenForce,
  };
};
